import * as TypeGraphQL from "type-graphql";
export var OptionExecutionSide;
(function (OptionExecutionSide) {
    OptionExecutionSide["BUY_TO_OPEN"] = "BUY_TO_OPEN";
    OptionExecutionSide["SELL_TO_CLOSE"] = "SELL_TO_CLOSE";
    OptionExecutionSide["SELL_TO_OPEN"] = "SELL_TO_OPEN";
    OptionExecutionSide["BUY_TO_CLOSE"] = "BUY_TO_CLOSE";
})(OptionExecutionSide || (OptionExecutionSide = {}));
TypeGraphQL.registerEnumType(OptionExecutionSide, {
    name: "OptionExecutionSide",
    description: undefined,
});
//# sourceMappingURL=OptionExecutionSide.js.map